import React from "react";

function QuotesResultsPage() {
	const params = new URLSearchParams(window.location.search);
	const registrationNumber = (
		params.get("registrationNumber") || "MH12AB1234"
	).toUpperCase();
	const makeModel = params.get("makeModel") || "Maruti Baleno";
	const fuel = params.get("fuel") || "Petrol";
	const policyType = params.get("policyType") || "Comprehensive";
	const policyExpiryDate = params.get("policyExpiryDate") || "2026-08-24";
	const ncb = params.get("ncb") || "0%";

	const [selectedAddons, setSelectedAddons] = React.useState([
		"Zero Depreciation",
	]);
	const [selectedAccidentCovers, setSelectedAccidentCovers] = React.useState(
		[],
	);
	const [selectedInsurerType, setSelectedInsurerType] = React.useState("All");
	const [sortBy, setSortBy] = React.useState("Premium: Low to High");
	const [selectedBreakupQuote, setSelectedBreakupQuote] = React.useState(null);
	const [isBreakupDrawerVisible, setIsBreakupDrawerVisible] =
		React.useState(false);
	const [selectedCompareQuotes, setSelectedCompareQuotes] = React.useState([]);
	const [isCompareDrawerOpen, setIsCompareDrawerOpen] = React.useState(false);
	const [isCompareDrawerVisible, setIsCompareDrawerVisible] =
		React.useState(false);

	const toggleSelection = (value, selectedValues, setSelectedValues) => {
		setSelectedValues((current) =>
			current.includes(value)
				? current.filter((item) => item !== value)
				: [...current, value],
		);
	};

	const quotes = [
		{
			company: "Zuno General Insurance",
			logo: "https://static.pbcdn.in/car-cdn/car2.0/insurer/39.png",
			idv: "Rs 5,18,940",
			premium: "Rs 1,146",
			accent: "from-mint to-sky",
			tag: "Approved garage advantage",
			perks: [
				"Zero depreciation available",
				"24x7 roadside assistance",
				"Policy details",
			],
			breakup: [
				{ label: "Own Damage Premium", value: "Rs 486" },
				{ label: "Third Party Premium", value: "Rs 431" },
				{ label: "PA Cover", value: "Rs 143" },
				{ label: "Add-on Charges", value: "Rs 52" },
				{ label: "GST", value: "Rs 34" },
			],
		},
		{
			company: "Generali Central",
			logo: "https://static.pbcdn.in/car-cdn/car2.0/insurer/14.png",
			idv: "Rs 5,96,280",
			premium: "Rs 1,582",
			accent: "from-peach to-coral",
			tag: "Balanced coverage",
			perks: ["Engine protect add-on", "Flexible claims", "Policy details"],
			breakup: [
				{ label: "Own Damage Premium", value: "Rs 708" },
				{ label: "Third Party Premium", value: "Rs 446" },
				{ label: "PA Cover", value: "Rs 121" },
				{ label: "Add-on Charges", value: "Rs 231" },
				{ label: "GST", value: "Rs 76" },
			],
		},
		{
			company: "United India Insurance",
			logo: "https://static.pbcdn.in/car-cdn/car2.0/insurer/11.png",
			idv: "Rs 6,31,420",
			premium: "Rs 1,874",
			accent: "from-sky to-mint",
			tag: "Flexi discount",
			perks: ["Free car servicing", "Add to compare", "Policy details"],
			breakup: [
				{ label: "Own Damage Premium", value: "Rs 801" },
				{ label: "Third Party Premium", value: "Rs 462" },
				{ label: "PA Cover", value: "Rs 126" },
				{ label: "Add-on Charges", value: "Rs 391" },
				{ label: "GST", value: "Rs 94" },
			],
		},
		{
			company: "Digit Insurance",
			logo: "https://static.pbcdn.in/car-cdn/car2.0/insurer/36.png",
			idv: "Rs 7,48,610",
			premium: "Rs 2,286",
			accent: "from-amber to-peach",
			tag: "Fast digital claims",
			perks: ["Pay by link", "Paperless policy", "Policy details"],
			breakup: [
				{ label: "Own Damage Premium", value: "Rs 1,018" },
				{ label: "Third Party Premium", value: "Rs 534" },
				{ label: "PA Cover", value: "Rs 141" },
				{ label: "Add-on Charges", value: "Rs 463" },
				{ label: "GST", value: "Rs 130" },
			],
		},
		{
			company: "ICICI Lombard",
			logo: "https://static.pbcdn.in/car-cdn/car2.0/insurer/3.png",
			idv: "Rs 6,76,950",
			premium: "Rs 2,034",
			accent: "from-coral to-peach",
			tag: "Wide garage network",
			perks: ["Consumables cover", "Doorstep support", "Policy details"],
			breakup: [
				{ label: "Own Damage Premium", value: "Rs 936" },
				{ label: "Third Party Premium", value: "Rs 487" },
				{ label: "PA Cover", value: "Rs 118" },
				{ label: "Add-on Charges", value: "Rs 372" },
				{ label: "GST", value: "Rs 121" },
			],
		},
	];

	const addons = [
		"Zero Depreciation",
		"24x7 Roadside Assistance",
		"Engine Protection Cover",
		"Consumables",
		"Key & Lock Replacement",
	];

	const accidentCovers = [
		"Owner-Driver PA Cover",
		"Paid driver cover",
		"Unnamed passenger cover",
	];
	const insurerTypes = ["All", "Public Sector", "Private Insurers"];

	const openPremiumBreakup = (quote) => {
		setSelectedBreakupQuote(quote);
	};

	React.useEffect(() => {
		if (selectedBreakupQuote) {
			const frame = window.requestAnimationFrame(() => {
				setIsBreakupDrawerVisible(true);
			});

			return () => window.cancelAnimationFrame(frame);
		}

		setIsBreakupDrawerVisible(false);
		return undefined;
	}, [selectedBreakupQuote]);

	const closePremiumBreakup = () => {
		setIsBreakupDrawerVisible(false);
		window.setTimeout(() => {
			setSelectedBreakupQuote(null);
		}, 280);
	};

	const toggleCompareQuote = (quote) => {
		setSelectedCompareQuotes((current) => {
			const exists = current.some((item) => item.company === quote.company);

			if (exists) {
				return current.filter((item) => item.company !== quote.company);
			}

			if (current.length >= 3) {
				return [...current.slice(1), quote];
			}

			return [...current, quote];
		});
	};

	React.useEffect(() => {
		if (selectedCompareQuotes.length === 0) {
			setIsCompareDrawerVisible(false);
			if (isCompareDrawerOpen) {
				window.setTimeout(() => {
					setIsCompareDrawerOpen(false);
				}, 280);
			}
		}
	}, [selectedCompareQuotes, isCompareDrawerOpen]);

	React.useEffect(() => {
		if (isCompareDrawerOpen) {
			const frame = window.requestAnimationFrame(() => {
				setIsCompareDrawerVisible(true);
			});

			return () => window.cancelAnimationFrame(frame);
		}

		setIsCompareDrawerVisible(false);
		return undefined;
	}, [isCompareDrawerOpen]);

	const openCompareDrawer = () => {
		if (selectedCompareQuotes.length > 0) {
			setIsCompareDrawerOpen(true);
		}
	};

	const closeCompareDrawer = () => {
		setIsCompareDrawerVisible(false);
		window.setTimeout(() => {
			setIsCompareDrawerOpen(false);
		}, 280);
	};

	return (
		<div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top_left,rgba(255,123,84,0.14),transparent_24%),radial-gradient(circle_at_85%_18%,rgba(121,189,232,0.14),transparent_18%),radial-gradient(circle_at_bottom_left,rgba(99,199,171,0.14),transparent_24%),linear-gradient(180deg,#f8fbff_0%,#f4f9ff_48%,#eef8f4_100%)] px-3 py-4 text-ink xl:overflow-visible">
			<div className="pointer-events-none absolute inset-0 opacity-70">
				<div className="absolute left-0 top-20 h-44 w-44 rounded-full bg-peach/12 blur-3xl"></div>
				<div className="absolute right-8 top-28 h-48 w-48 rounded-full bg-sky/15 blur-3xl"></div>
			</div>

			<div className="relative mx-auto max-w-[1440px]">
				<div className="rounded-[24px] border border-white/90 bg-[linear-gradient(90deg,rgb(255,240,232)_0%,rgb(255,247,239)_48%,rgb(255,252,246)_100%)] px-4 pb-5 pt-4 text-ink shadow-[0_22px_44px_rgba(225,95,56,0.12)] md:px-6">
					<div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
						<div className="flex flex-wrap items-center gap-4">
							<div className="grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-peach to-coral text-xl font-extrabold text-white shadow-[0_14px_26px_rgba(225,95,56,0.2)]">
								CG
							</div>
							<div>
								<h1 className="font-display text-2xl font-bold tracking-[-0.04em]">
									{makeModel.toUpperCase()}
								</h1>
								<p className="mt-1 text-sm text-slate-500">
									{registrationNumber} | {fuel} | {policyType}
								</p>
							</div>
						</div>

						<div className="flex flex-col gap-3 xl:items-end">
							<a
								href="/agent-dashboard"
								className="inline-flex items-center justify-center rounded-full border border-white/80 bg-white/75 px-4 py-2 text-sm font-semibold text-slate-600 shadow-[0_10px_20px_rgba(43,74,107,0.05)] transition hover:-translate-y-0.5 hover:text-coral"
							>
								Dashboard
							</a>

							<div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
							{[
								{
									label: "Edit",
									value: "Vehicle Details",
									href: `/vehicle-details?registrationNumber=${encodeURIComponent(registrationNumber)}&makeModel=${encodeURIComponent(makeModel)}&fuel=${encodeURIComponent(fuel)}&policyType=${encodeURIComponent(policyType)}&policyExpiryDate=${encodeURIComponent(policyExpiryDate)}&ncb=${encodeURIComponent(ncb)}`,
								},
								{ label: "IDV Cover", value: "Select IDV" },
								{ label: "No Claim Bonus", value: ncb },
								{
									label: "OD Expiry Date",
									value: new Date(policyExpiryDate).toLocaleDateString(
										"en-GB",
										{
											day: "2-digit",
											month: "short",
											year: "numeric",
										},
									),
								},
							].map((item) => (
								<div
									key={item.label}
									className="rounded-[18px] border border-white/80 bg-white/75 px-4 py-3 shadow-[0_10px_20px_rgba(43,74,107,0.05)]"
								>
									<p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
										{item.label}
									</p>
									{item.href ? (
										<a
											href={item.href}
											className="mt-1 inline-block text-sm font-semibold text-coral underline decoration-coral/30 underline-offset-4"
										>
											{item.value}
										</a>
									) : (
										<p className="mt-1 text-sm font-semibold text-ink">
											{item.value}
										</p>
									)}
								</div>
							))}
							</div>
						</div>
					</div>
				</div>

				<div className="mt-4 grid gap-4 xl:grid-cols-[290px_1fr] xl:items-start">
					<aside className="space-y-4 xl:sticky xl:top-6 xl:max-h-[calc(100vh-48px)] xl:self-start xl:overflow-y-auto">
						<div className="rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.90)_0%,rgba(245,249,255,0.96)_100%)] p-4 shadow-[0_18px_38px_rgba(43,74,107,0.08)]">
							<div className="flex items-center gap-2">
								<span className="text-lg text-slate-500">=</span>
								<h2 className="text-xl font-bold text-slate-700">Filter</h2>
							</div>

							<div className="mt-5 space-y-5">
								<div>
									<div className="flex items-center justify-between">
										<h3 className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
											Addons
										</h3>
										<span className="text-slate-300">-</span>
									</div>
									<div className="mt-3 space-y-3">
										{addons.map((item) => (
											<label
												key={item}
												className="flex items-center gap-3 text-sm font-medium text-slate-600"
											>
												<input
													type="checkbox"
													checked={selectedAddons.includes(item)}
													onChange={() =>
														toggleSelection(
															item,
															selectedAddons,
															setSelectedAddons,
														)
													}
													className="h-4 w-4 rounded border-slate-300 text-coral focus:ring-coral"
												/>
												<span>{item}</span>
											</label>
										))}
									</div>
								</div>

								<div className="border-t border-slate-100 pt-4">
									<div className="flex items-center justify-between">
										<h3 className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
											Accident Covers
										</h3>
										<span className="text-slate-300">-</span>
									</div>
									<div className="mt-3 space-y-3">
										{accidentCovers.map((item) => (
											<label
												key={item}
												className="flex items-center gap-3 text-sm font-medium text-slate-600"
											>
												<input
													type="checkbox"
													checked={selectedAccidentCovers.includes(item)}
													onChange={() =>
														toggleSelection(
															item,
															selectedAccidentCovers,
															setSelectedAccidentCovers,
														)
													}
													className="h-4 w-4 rounded border-slate-300 text-coral focus:ring-coral"
												/>
												<span>{item}</span>
											</label>
										))}
									</div>
								</div>

								<div className="border-t border-slate-100 pt-4">
									<div className="flex items-center justify-between">
										<h3 className="text-sm font-bold uppercase tracking-[0.14em] text-slate-500">
											Insurer Type
										</h3>
										<span className="text-slate-300">-</span>
									</div>
									<div className="mt-3 flex flex-wrap gap-2">
										{insurerTypes.map((item) => (
											<button
												key={item}
												type="button"
												onClick={() => setSelectedInsurerType(item)}
												className={`rounded-full px-3 py-2 text-sm font-semibold transition ${
													selectedInsurerType === item
														? "bg-gradient-to-r from-peach to-coral text-white shadow-[0_10px_20px_rgba(225,95,56,0.18)]"
														: "border border-slate-200 bg-white/80 text-slate-600"
												}`}
											>
												{item}
											</button>
										))}
									</div>
								</div>
							</div>
						</div>
					</aside>

					<main
						className={`space-y-4 ${selectedCompareQuotes.length > 0 ? "pb-36" : ""}`}
					>
						<div className="flex flex-col gap-4 rounded-[24px] border border-white/90 bg-[linear-gradient(180deg,rgb(255,251,247)_0%,rgb(255,255,255)_100%)] px-4 py-4 shadow-[0_16px_32px_rgba(43,74,107,0.08)] md:flex-row md:items-start md:justify-between md:px-5">
							<div>
								<h2 className="font-display text-3xl font-bold tracking-[-0.04em] text-ink">
									{quotes.length}{" "}
									{policyType === "Third Party Only"
										? "Third Party"
										: "Own Damage"}{" "}
									plans
								</h2>
								<p className="mt-1 text-base text-slate-500">
									Compare quotations from multiple insurers for your vehicle.
								</p>
							</div>

							<div className="flex items-center gap-3">
								<label className="text-sm font-bold text-slate-500">
									Sort By
								</label>
								<select
									value={sortBy}
									onChange={(event) => setSortBy(event.target.value)}
									className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-ink shadow-[0_10px_20px_rgba(43,74,107,0.05)] outline-none"
								>
									{[
										"Premium: Low to High",
										"Premium: High to Low",
										"Highest IDV",
										"Best Value",
									].map((item) => (
										<option key={item} value={item}>
											{item}
										</option>
									))}
								</select>
							</div>
						</div>

						<div className="space-y-4">
							{quotes.map((quote, index) => (
								<article
									key={quote.company}
									className="overflow-hidden rounded-[24px] border border-white/80 bg-[linear-gradient(180deg,rgba(255,255,255,0.96)_0%,rgba(247,251,255,0.98)_100%)] shadow-[0_18px_38px_rgba(43,74,107,0.08)]"
								>
									<div className="border-b border-slate-100 px-5 py-4">
										<div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
											<div className="flex items-center gap-4">
												<div className="flex h-16 w-32 items-center justify-center overflow-hidden rounded-[18px] border border-slate-100 bg-white shadow-[0_16px_30px_rgba(43,74,107,0.08)]">
													<div className="flex h-full w-full items-center justify-center">
														<img
															src={quote.logo}
															alt={`${quote.company} logo`}
															className="max-h-9 w-auto object-contain"
															loading="lazy"
														/>
													</div>
												</div>
												<div>
													<p className="text-lg font-bold text-slate-700">
														{quote.company}
													</p>
													<p className="mt-1 text-sm text-slate-400">
														{quote.tag}
													</p>
												</div>
											</div>

											<div className="grid gap-3 sm:grid-cols-[160px_148px]">
												<div className="flex min-h-[84px] flex-col justify-center rounded-[18px] border border-slate-100 bg-slate-50 px-4 py-2.5">
													<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
														IDV
													</p>
													<p className="mt-1 text-[1.35rem] font-bold leading-tight text-ink">
														{quote.idv}
													</p>
												</div>
												<button
													type="button"
													className="flex min-h-[84px] items-center rounded-[18px] bg-gradient-to-r from-peach to-coral px-4 py-2.5 text-left text-white shadow-[0_16px_30px_rgba(225,95,56,0.22)] transition hover:-translate-y-0.5"
												>
													<div className="flex items-center justify-between gap-4">
														<div>
															<p className="text-xs font-bold uppercase tracking-[0.14em] text-white/70">
																Premium
															</p>
															<p className="mt-1 text-[1.2rem] font-bold leading-tight">
																{quote.premium}
															</p>
														</div>
														<span className="text-lg font-semibold">&gt;</span>
													</div>
												</button>
											</div>
										</div>
									</div>

									<div className="px-5 py-4">
										{index === 0 ? (
											<div className="rounded-[18px] border border-coral/30 bg-[linear-gradient(180deg,rgba(255,123,84,0.08)_0%,rgba(255,255,255,0.92)_100%)] px-4 py-3 text-sm text-slate-600">
												Enjoy discount for approved garages. Claims can be made
												only at eligible garages.
											</div>
										) : null}

										{index === 2 ? (
											<div className="mt-3 rounded-[18px] border border-mint/25 bg-[linear-gradient(180deg,rgba(99,199,171,0.12)_0%,rgba(255,255,255,0.94)_100%)] px-4 py-3">
												<div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
													<div>
														<p className="text-sm font-bold text-slate-700">
															Flexi Discount
														</p>
														<p className="mt-1 text-sm text-slate-500">
															Choose your discount and see the premium update
															instantly.
														</p>
													</div>
													<div className="flex items-center gap-3">
														<span className="text-sm font-semibold text-slate-500">
															0%
														</span>
														<div className="h-3 w-28 rounded-full bg-slate-200">
															<div className="h-3 w-20 rounded-full bg-gradient-to-r from-coral to-amber"></div>
														</div>
														<span className="text-sm font-semibold text-slate-500">
															90%
														</span>
														<button
															type="button"
															className="rounded-xl border border-peach/30 bg-white px-4 py-2 text-sm font-semibold text-coral"
														>
															Apply
														</button>
													</div>
												</div>
											</div>
										) : null}

										{index === 3 ? (
											<div className="mt-3 rounded-[18px] bg-gradient-to-r from-amber to-coral px-4 py-2.5 text-sm font-semibold text-white shadow-[0_12px_24px_rgba(240,178,71,0.18)]">
												PAYD Bonanza - Earn additional Rs 100 on every booking!
											</div>
										) : null}

										<div className="mt-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
											<div className="flex flex-wrap gap-2">
												{quote.perks.map((perk) => (
													<span
														key={perk}
														className="rounded-full border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-500"
													>
														{perk}
													</span>
												))}
											</div>

											<div className="flex flex-wrap items-center gap-3 md:justify-end">
												<label className="flex items-center gap-2 text-sm font-medium text-slate-500">
													<input
														type="checkbox"
														checked={selectedCompareQuotes.some(
															(item) => item.company === quote.company,
														)}
														onChange={() => toggleCompareQuote(quote)}
														className="h-4 w-4 rounded border-slate-300 text-coral focus:ring-coral"
													/>
													<span>Add to compare</span>
												</label>

												<button
													type="button"
													onClick={() => openPremiumBreakup(quote)}
													className="inline-flex h-10 items-center gap-2 rounded-full border border-peach/20 bg-peach/10 px-3.5 text-sm font-semibold text-coral transition hover:bg-peach/15"
												>
													<span>Premium Breakup</span>
													<span className="text-base leading-none">&gt;</span>
												</button>
											</div>
										</div>
									</div>
								</article>
							))}
						</div>
					</main>
				</div>
			</div>

			{selectedCompareQuotes.length > 0 ? (
				<div className="fixed bottom-4 left-1/2 z-40 w-[calc(100%-24px)] max-w-[1180px] -translate-x-1/2 px-1 md:w-[calc(100%-48px)]">
					<div className="flex flex-col gap-4 rounded-[24px] border border-peach/20 bg-[linear-gradient(180deg,rgba(255,243,236,0.94)_0%,rgba(255,255,255,0.98)_100%)] px-4 py-4 shadow-[0_18px_34px_rgba(225,95,56,0.14)] backdrop-blur-sm sm:flex-row sm:items-center sm:justify-between sm:px-5">
						<div className="flex flex-col gap-2">
							<p className="text-sm font-bold text-coral">
								{selectedCompareQuotes.length} plan
								{selectedCompareQuotes.length > 1 ? "s" : ""} selected for
								overall comparison
							</p>
							<div className="flex flex-wrap gap-2">
								{selectedCompareQuotes.map((quote) => (
									<span
										key={quote.company}
										className="rounded-full border border-white/80 bg-white/70 px-3 py-2 text-sm font-semibold text-slate-600 shadow-[0_8px_18px_rgba(43,74,107,0.05)]"
									>
										{quote.company}
									</span>
								))}
							</div>
						</div>

						<button
							type="button"
							onClick={openCompareDrawer}
							className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-peach to-coral px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_26px_rgba(225,95,56,0.18)] transition hover:-translate-y-0.5"
						>
							<span>View Comparison</span>
							<span>&gt;</span>
						</button>
					</div>
				</div>
			) : null}

			{selectedBreakupQuote ? (
				<div
					className={`fixed inset-0 z-50 backdrop-blur-sm transition duration-300 ${
						isBreakupDrawerVisible
							? "bg-ink/25 opacity-100"
							: "bg-ink/0 opacity-0"
					}`}
				>
					<button
						type="button"
						aria-label="Close premium breakup drawer"
						onClick={closePremiumBreakup}
						className="absolute inset-0 h-full w-full cursor-default"
					/>

					<aside
						className={`absolute right-0 top-0 h-full w-full max-w-[440px] overflow-y-auto border-l border-white/80 bg-[linear-gradient(180deg,rgba(255,249,244,0.98)_0%,rgba(247,251,255,0.99)_100%)] px-6 py-6 shadow-[-24px_0_60px_rgba(43,74,107,0.18)] transition duration-300 ease-out ${
							isBreakupDrawerVisible
								? "translate-x-0 opacity-100"
								: "translate-x-full opacity-0"
						}`}
					>
						<div className="flex items-start justify-between gap-4">
							<div>
								<div className="inline-flex rounded-full border border-peach/15 bg-peach/10 px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] text-coral">
									Premium Breakup
								</div>
								<h2 className="mt-4 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
									{selectedBreakupQuote.company}
								</h2>
								<p className="mt-2 text-sm text-slate-500">
									Detailed premium view for the selected quotation.
								</p>
							</div>

							<button
								type="button"
								onClick={closePremiumBreakup}
								className="grid h-10 w-10 place-items-center rounded-full border border-white/90 bg-white text-xl text-slate-400 shadow-[0_10px_22px_rgba(53,85,130,0.08)] transition hover:-translate-y-0.5 hover:text-ink"
							>
								x
							</button>
						</div>

						<div className="mt-6 flex items-center gap-4 rounded-[22px] border border-white/80 bg-white/80 p-4 shadow-[0_12px_28px_rgba(43,74,107,0.06)]">
							<div className="flex h-16 w-28 items-center justify-center overflow-hidden rounded-[18px] border border-slate-100 bg-white shadow-[0_16px_30px_rgba(43,74,107,0.08)]">
								<div className="flex h-full w-full items-center justify-center">
									<img
										src={selectedBreakupQuote.logo}
										alt={`${selectedBreakupQuote.company} logo`}
										className="max-h-9 w-auto object-contain"
										loading="lazy"
									/>
								</div>
							</div>
							<div>
								<p className="text-sm font-bold uppercase tracking-[0.14em] text-slate-400">
									Quoted Premium
								</p>
								<p className="mt-1 text-2xl font-bold text-coral">
									{selectedBreakupQuote.premium}
								</p>
								<p className="mt-1 text-sm text-slate-500">
									IDV: {selectedBreakupQuote.idv}
								</p>
							</div>
						</div>

						<div className="mt-6 rounded-[24px] border border-peach/15 bg-[linear-gradient(180deg,rgba(255,247,241,0.72)_0%,rgba(255,255,255,0.96)_100%)] p-5 shadow-[0_14px_28px_rgba(43,74,107,0.06)]">
							<div className="space-y-4">
								{selectedBreakupQuote.breakup.map((item) => (
									<div
										key={item.label}
										className="flex items-center justify-between gap-4 border-b border-slate-100 pb-4 text-sm last:border-b-0 last:pb-0"
									>
										<span className="font-medium text-slate-500">
											{item.label}
										</span>
										<span className="font-bold text-ink">{item.value}</span>
									</div>
								))}
							</div>
						</div>

						<div className="mt-5 rounded-[22px] border border-white/80 bg-white/80 p-4 shadow-[0_12px_24px_rgba(43,74,107,0.05)]">
							<div className="flex items-center justify-between gap-4">
								<span className="text-sm font-bold uppercase tracking-[0.12em] text-coral">
									Final Premium
								</span>
								<span className="text-2xl font-bold text-coral">
									{selectedBreakupQuote.premium}
								</span>
							</div>
						</div>
					</aside>
				</div>
			) : null}

			{isCompareDrawerOpen ? (
				<div
					className={`fixed inset-0 z-50 backdrop-blur-sm transition duration-300 ${
						isCompareDrawerVisible
							? "bg-ink/20 opacity-100"
							: "bg-ink/0 opacity-0"
					}`}
				>
					<button
						type="button"
						aria-label="Close compare drawer"
						onClick={closeCompareDrawer}
						className="absolute inset-0 h-full w-full cursor-default"
					/>

					<aside
						className={`absolute right-0 top-0 h-full w-full max-w-[980px] overflow-y-auto border-l border-white/80 bg-[linear-gradient(180deg,rgba(255,249,244,0.98)_0%,rgba(247,251,255,0.99)_100%)] px-6 py-6 shadow-[-24px_0_60px_rgba(43,74,107,0.18)] transition duration-300 ease-out ${
							isCompareDrawerVisible
								? "translate-x-0 opacity-100"
								: "translate-x-full opacity-0"
						}`}
					>
						<div className="flex items-start justify-between gap-4">
							<div>
								<div className="inline-flex rounded-full border border-peach/15 bg-peach/10 px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] text-coral">
									Compare Plans
								</div>
								<h2 className="mt-4 font-display text-3xl font-bold tracking-[-0.04em] text-ink">
									Compare selected quotations
								</h2>
								<p className="mt-2 text-sm text-slate-500">
									Side-by-side comparison of the plans you shortlisted.
								</p>
							</div>

							<button
								type="button"
								onClick={closeCompareDrawer}
								className="grid h-10 w-10 place-items-center rounded-full border border-white/90 bg-white text-xl text-slate-400 shadow-[0_10px_22px_rgba(53,85,130,0.08)] transition hover:-translate-y-0.5 hover:text-ink"
							>
								x
							</button>
						</div>

						<div className="mt-6 grid gap-4 lg:grid-cols-2 xl:grid-cols-3">
							{selectedCompareQuotes.map((quote) => (
								<article
									key={quote.company}
									className="rounded-[24px] border border-white/80 bg-white/86 p-5 shadow-[0_16px_32px_rgba(43,74,107,0.08)]"
								>
									<div className="flex h-16 w-32 items-center justify-center overflow-hidden rounded-[18px] border border-slate-100 bg-white shadow-[0_16px_30px_rgba(43,74,107,0.08)]">
										<div className="flex h-full w-full items-center justify-center">
											<img
												src={quote.logo}
												alt={`${quote.company} logo`}
												className="max-h-9 w-auto object-contain"
												loading="lazy"
											/>
										</div>
									</div>

									<h3 className="mt-4 text-lg font-bold text-slate-700">
										{quote.company}
									</h3>
									<p className="mt-1 text-sm text-slate-400">{quote.tag}</p>

									<div className="mt-5 grid gap-3 sm:grid-cols-2">
										<div className="rounded-[18px] border border-slate-100 bg-slate-50 px-4 py-3">
											<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
												Premium
											</p>
											<p className="mt-1 text-xl font-bold text-coral">
												{quote.premium}
											</p>
										</div>
										<div className="rounded-[18px] border border-slate-100 bg-slate-50 px-4 py-3">
											<p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
												IDV
											</p>
											<p className="mt-1 text-xl font-bold text-ink">
												{quote.idv}
											</p>
										</div>
									</div>

									<div className="mt-5 space-y-3">
										{quote.breakup.map((item) => (
											<div
												key={item.label}
												className="flex items-center justify-between gap-3 rounded-[16px] border border-white/70 bg-[linear-gradient(180deg,rgba(255,247,241,0.72)_0%,rgba(255,255,255,0.96)_100%)] px-4 py-3 text-sm"
											>
												<span className="font-medium text-slate-500">
													{item.label}
												</span>
												<span className="font-bold text-ink">{item.value}</span>
											</div>
										))}
									</div>

									<div className="mt-5 flex flex-wrap gap-2">
										{quote.perks.map((perk) => (
											<span
												key={perk}
												className="rounded-full border border-slate-200 bg-slate-50 px-3 py-2 text-xs font-medium text-slate-500"
											>
												{perk}
											</span>
										))}
									</div>

									<button
										type="button"
										className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-[16px] bg-gradient-to-r from-peach to-coral px-4 py-3 text-sm font-semibold text-white shadow-[0_14px_26px_rgba(225,95,56,0.18)] transition hover:-translate-y-0.5"
									>
										<span>Buy Now</span>
										<span>&gt;</span>
									</button>
								</article>
							))}
						</div>
					</aside>
				</div>
			) : null}
		</div>
	);
}

window.AppPages = window.AppPages || {};
window.AppPages.QuotesResultsPage = QuotesResultsPage;
